/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetDiagnosticHistoryItemResponseDto } from './AssetDiagnosticHistoryItemResponseDto';
import {
    AssetDiagnosticHistoryItemResponseDtoFromJSON,
    AssetDiagnosticHistoryItemResponseDtoFromJSONTyped,
    AssetDiagnosticHistoryItemResponseDtoToJSON,
    AssetDiagnosticHistoryItemResponseDtoToJSONTyped,
} from './AssetDiagnosticHistoryItemResponseDto';
import type { PaginationMetaDto } from './PaginationMetaDto';
import {
    PaginationMetaDtoFromJSON,
    PaginationMetaDtoFromJSONTyped,
    PaginationMetaDtoToJSON,
    PaginationMetaDtoToJSONTyped,
} from './PaginationMetaDto';

/**
 * 
 * @export
 * @interface ListAssetDiagnosticsResponseDto
 */
export interface ListAssetDiagnosticsResponseDto {
    /**
     * 
     * @type {Array<AssetDiagnosticHistoryItemResponseDto>}
     * @memberof ListAssetDiagnosticsResponseDto
     */
    data: Array<AssetDiagnosticHistoryItemResponseDto>;
    /**
     * 
     * @type {PaginationMetaDto}
     * @memberof ListAssetDiagnosticsResponseDto
     */
    meta: PaginationMetaDto;
}

/**
 * Check if a given object implements the ListAssetDiagnosticsResponseDto interface.
 */
export function instanceOfListAssetDiagnosticsResponseDto(value: object): value is ListAssetDiagnosticsResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListAssetDiagnosticsResponseDtoFromJSON(json: any): ListAssetDiagnosticsResponseDto {
    return ListAssetDiagnosticsResponseDtoFromJSONTyped(json, false);
}

export function ListAssetDiagnosticsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAssetDiagnosticsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(AssetDiagnosticHistoryItemResponseDtoFromJSON)),
        'meta': PaginationMetaDtoFromJSON(json['meta']),
    };
}

export function ListAssetDiagnosticsResponseDtoToJSON(json: any): ListAssetDiagnosticsResponseDto {
    return ListAssetDiagnosticsResponseDtoToJSONTyped(json, false);
}

export function ListAssetDiagnosticsResponseDtoToJSONTyped(value?: ListAssetDiagnosticsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(AssetDiagnosticHistoryItemResponseDtoToJSON)),
        'meta': PaginationMetaDtoToJSON(value['meta']),
    };
}

